@if (content && content.title) {
  <h3>{{ content.title }}</h3>
}

@if (content) {
  <div class="card mb-3">
    <div class="row g-0" [class.reverse]="content.alignment == 'reversed'">
      <div class="col-md-7">
        <wagtail-page-element-image
          [image]="content.picture_tag_info"
          [class]="'h-100'"
        ></wagtail-page-element-image>
      </div>
      <div class="col-md-5 d-flex flex-column">
        <div class="card-body">
          <h5 class="card-title" aria-level="4">{{ content.card_title }}</h5>
          <p class="card-text">{{ content.card_text }}</p>
        </div>
        @if (content.button_text && content.button_url) {
          <div class="card-footer">
            <a href="{{ content.button_url | wagtailUrl }}" class="btn btn-black">{{ content.button_text }}</a>
          </div>
        }
      </div>
    </div>
  </div>
}